import {
  resendUserTemporaryPassword as RESEND_USER_TEMPORARY_PASSWORD,
  ResendUserTemporaryPasswordMutation,
  ResendUserTemporaryPasswordMutationVariables,
} from '@admiin-com/ds-graphql';
import { gql, useMutation } from '@apollo/client';

export const isUserAlreadyCompletedSignupError = (error?: Error): boolean => {
  if (!error) return false;
  return error.message.includes('USER_ALREADY_COMPLETED_SIGNUP');
};

export function useResendTemporaryPassword() {
  const [resendTemporaryPassword, result] = useMutation<
    ResendUserTemporaryPasswordMutation,
    ResendUserTemporaryPasswordMutationVariables
  >(gql(RESEND_USER_TEMPORARY_PASSWORD));

  const isUserAlreadyCompletedSignup = isUserAlreadyCompletedSignupError(
    result.error as Error
  );

  return [
    resendTemporaryPassword,
    {
      ...result,
      isUserAlreadyCompletedSignup,
    },
  ] as const;
}
